import { render, staticRenderFns } from "./Nav.vue?vue&type=template&id=c3979d78&scoped=true"
var script = {}
import style0 from "./Nav.vue?vue&type=style&index=0&id=c3979d78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3979d78",
  null
  
)

export default component.exports